import React, {FC} from "react"
import {Row, Col} from "react-bootstrap"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"
import {BirthdayBoxMetadata} from "@irati/types"
import {Hr} from "@irati/ui/src/Layout"
import {H4} from "@irati/ui/src/Typography"

import BirthdayBoxCard from "./Card"

interface Props {
  metadata: BirthdayBoxMetadata[],
  id?: string
}

const StyledCol = styled(Col)`
  display: inline-block;
  float: none;
`

const BirthdayBox: FC<Props> = ({metadata, ...props}) => {
  const idNamespace = id("birthday-box-list", props)
  return (
    <>
      <Hr />
      <Row>
        <Col xs={12}>
          <Flex margin={[0, 0, 3, 0]}>
            <H4 marginBottom={2}>
              <FormattedMessage id="perks.components.birthdayBox.title" />
            </H4>
          </Flex>
        </Col>
      </Row>
      <Row>
        {metadata.map((boxMetadata, index) => (
          <StyledCol key={`column-${boxMetadata.productId}`} id={id(`column-${index}`, idNamespace)} xs={12} sm={6} md={4}>
            <BirthdayBoxCard metadata={boxMetadata} />
          </StyledCol>
        ))}
      </Row>
    </>
  )
}

export default BirthdayBox
